import { useState, useMemo, ReactNode } from 'react';

import { createDefaultProviderNavigationState } from './providerNavigationUtils';
import {
  ProviderNavigationContext,
  type ProviderNavigationContextType,
  type ProviderNavigationState,
} from './ProviderNavigationContextTypes';

// Re-export types for convenience
export type { ProviderNavigationState };

interface ProviderNavigationProviderProps {
  children: ReactNode;
}

export const ProviderNavigationProvider = ({ children }: ProviderNavigationProviderProps) => {
  const [providerNavigation, setProviderNavigation] = useState<ProviderNavigationState>(() =>
    createDefaultProviderNavigationState()
  );

  const value = useMemo<ProviderNavigationContextType>(
    () => ({
      providerNavigation,
      setProviderNavigation,
    }),
    [providerNavigation]
  );

  return (
    <ProviderNavigationContext.Provider value={value}>
      {children}
    </ProviderNavigationContext.Provider>
  );
};
